"use client";
import LinkButton from "@/components/LinkButton/LinkButton";
import { calendlyUrl } from "@/modules/sales/sales.consts";
import { scrollFx } from "@/modules/visual/scrollFx";
import { FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

interface BookSectionHomeProps {}

const BookSectionHome: FunctionComponent<BookSectionHomeProps> = () => {
  return (
    <section
      className="pt-16 pb-16"
      {...scrollFx({ trigger: "enter", effect: "slide", from: "right" })}
    >
      <div className="max-w-[80%] mx-auto">
        <div className="flex flex-col md:!flex-row my-8 md:my-3">
          <p className="text-5xl font-bold tracking-tight w-auto lg:w-1/2">
            <FormattedMessage
              defaultMessage="home.book.section.title"
              id="home.book.section.title"
            />
          </p>
          <div className="w-auto lg:w-1/2 flex justify-start lg:justify-end pt-6 lg:pt-0">
            <LinkButton href={calendlyUrl} isNewTab>
              <span>
                <FormattedMessage
                  defaultMessage="Book a call"
                  id="generic.contactUs.calendly"
                />
              </span>
            </LinkButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSectionHome;
